import { CustomDataSource, Rectangle, ImageMaterialProperty } from 'cesium';
import {transformGeometry} from '../feature-layer/createFeatureCollection';
import h337 from 'heatmap.js';

const getData = (data, width, height) => {
    let list = data.map(v => {
        let {geometryInfo} = v;
        let [x, y] = transformGeometry(geometryInfo).coordinates;

        return {
            ...v,
            x,
            y,
        }
    });

    // 获取边界数据
    const value = 0.1;
    let latMin = Math.min(...list.map(point => point.y)) - value;
    let latMax = Math.max(...list.map(point => point.y)) + value;
    let lonMin = Math.min(...list.map(point => point.x)) - value;
    let lonMax = Math.max(...list.map(point => point.x)) + value;

    list = list.map(v => ({
        ...v,
        x: Math.floor(((v.x - lonMin) / (lonMax - lonMin)) * width),
        y: Math.floor(((v.y - latMin) / (latMax - latMin)) * height),
    }))

    return {
        data: list,
        latMin,
        latMax,
        lonMin,
        lonMax,
        max: 10,
        min: 0
    }
}

class HeatmapLayer extends CustomDataSource{
    constructor(options) {
        super();

        this.map = options.map;

        this.container = this.createDom();
        this.layer = h337.create({
            container: this.container,
        })

        if (options.data?.length) {
            this.loadData(options.data);
        }
    }

    createDom() {
        const map = this.map;
        const {width, height} = map.container.getBoundingClientRect();

        const heatMapDom = document.createElement('div');
        heatMapDom.style.width = width + 'px';
        heatMapDom.style.height = height + 'px';
        heatMapDom.style.display = 'none';

        map.container.appendChild(heatMapDom);

        return heatMapDom;
    }

    loadData(_data) {
        const map = this.map;

        this.entities.removeAll();

        const {width, height} = map.container.getBoundingClientRect();

        const {data, max, min, lonMin, latMin, lonMax, latMax} = getData(_data, width, height);

        this.layer.setData({
            max,
            min,
            data
        });

        // 生成的热力图 canvas 元素类名为 heatmap-canvas
        const canvas = document.getElementsByClassName('heatmap-canvas');
        if (!canvas[0]) return;

        this.entities.add({
            name: 'heatmap',
            rectangle: {
                coordinates: Rectangle.fromDegrees(lonMin, latMin, lonMax, latMax),
                material: new ImageMaterialProperty({
                    image: canvas[0],
                    transparent: true,
                }),
            },
        })
    }

    destroy() {
        const map = this.map;
        this.container && map.container.removeChild(this.container);
    }
}


export default HeatmapLayer;
